var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" Your monitors have been automatically paused due to inactivity on your account. You can resume them at any time. ")])}
var staticRenderFns = []

export { render, staticRenderFns }